<template>
  <div>
    <router-view />
    <loading />
  </div>
</template>

<script>
import Loading from './components/Loading.vue';
export default {
  components: { Loading },
  mounted() {
    document.domain = "eduwill.net";
  }
}
</script>

<style>

</style>